import React from 'react';

interface DropdownProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  value: string;
  minWidth?: number; // in ch units
  className?: string;
  options: { value: string; label: string }[];
  textVariant?: string;
  borderVariant?: string;
}

const getBootstrapColor = (variant?: string) => {
  if (!variant) return undefined;
  return `var(--bs-${variant})`;
};

const Dropdown = ({ 
  value, 
  minWidth = 1, 
  className,
  style,
  options,
  textVariant,
  borderVariant,
  ...props 
}: DropdownProps) => {
  // Find the selected option to determine width
  const selectedOption = options.find(opt => opt.value === value);
  const textToMeasure = selectedOption ? selectedOption.label : '';
  const length = textToMeasure.length;
  const effectiveWidth = Math.max(length, minWidth);

  const color = getBootstrapColor(textVariant);
  const borderColor = getBootstrapColor(borderVariant);

  return (
    <select
      value={value}
      style={{
        background: 'transparent',
        border: `1px dashed ${borderColor || 'var(--bs-border-color, #666)'}`,
        color: color || 'var(--bs-body-color, inherit)',
        fontFamily: 'inherit',
        padding: '0.5rem 2rem 0.5rem 1rem', // Extra right padding for arrow
        display: 'inline-block',
        width: `calc(${effectiveWidth}ch + 4rem)`, // Padding + arrow buffer
        transition: 'width 0.3s ease-out',
        cursor: 'pointer',
        ...style,
      }}
      className={['of-themed-dropdown', className].filter(Boolean).join(' ')}
      {...props}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
};

export default Dropdown;
